import { FinanceReportInterface } from '../interfaces'

export const getTotalCars = (report: FinanceReportInterface[]) => {
  return report.reduce((total, item) => total + item.carwashCarCounterTotal, 0)
}
